let initialState = {
	outstandingReports: [],
};

const OutstandingReportsReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_OUTSTANDING_REPORTS':
			return {
				...state,
				outstandingReports: action.payload,
			};
		default:
			return state;
	}
};

export { OutstandingReportsReducer };
